//OMDB API
const APIToken = '47203f8b'

module.exports = {
  APIToken
}
